<div class="search-dd">
  <div class="searchContainer">
    <input
      #searchBox
      class="searchBox"
      autocomplete="no-autofill"
      [formControl]="searchControl"
      type="search"
      placeholder="{{ 'shared.search' | xTranslate }} {{ 'user.' + entity.toLowerCase() | xTranslate | uppercase }}"
    />
    <mat-icon class="search">search</mat-icon>
  </div>
  <div class="searchResults">
    <ul>
      <li *ngFor="let record of textSearch | async" (click)="addRecord(record)">
        {{ record.value }}
      </li>
    </ul>
    <span *ngIf="!textSearch && (textSearch | async).length === 0" l10nTranslate>shared.noRecords</span>
  </div>
  <ng-content></ng-content>
</div>
